export default defineNuxtPlugin(() => {
    if (!process.client) return
    
    const { cookiesEnabledIds } = useCookieControl()
    const router = useRouter()
    
    function allConsentGranted() {
        const { gtag, enableAnalytics } = useGtag()
        console.log("All consent granted, updating gtag consent settings")
        gtag('consent', 'update', {
            ad_user_data: 'granted',
            ad_personalization: 'granted',
            ad_storage: 'granted',
            analytics_storage: 'granted'
        })
    }

     function allConsentDenied() {
        const { gtag, disableAnalytics } = useGtag()
        gtag('consent', 'update', {
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            ad_storage: 'denied',
            analytics_storage: 'denied'
        })
    }
    
    const COOKIE_KEY = 'ga' // ⬅️ Hier anpassen
    
    watch(
        () => cookiesEnabledIds.value,
        (cookies) => {
            if (!cookies) return
            
            if (cookies.includes(COOKIE_KEY)) {
                allConsentGranted()
            } else {
               allConsentDenied()
            }
            if(cookies.includes('hotjar')) {
                const { initialize } = useHotjar()
                initialize()
            }
        },
        { immediate: true }
    )
})